module.exports = __webpack_public_path__ + "media/images/admin/icons/file-57e885a5946e533ebd772668f05b8844.svg";